import RedirectComponent from './redirect/redirect';

// Re-export from centralized routes
export {
  MonitorV2,
  Analyze,
  AnalyzeV2,
  Investigate,
  LimitsV2,
  TimeSearch,
  AlertPage,
  AlertManager,
  AlertBoardV2,
  Share,
  ShareV2,
  ShareCollection,
  AlertViewV2,
  ManagePage,
  ViewPage,
} from '../../app-v2/routes';

// Default (non-lazy components)
export const Redirect = RedirectComponent;
